import { canShowIconBeforeByFrequency } from './priority';

const ICON_WINNER_KEY = '_cartsee_icon_winner_id';

// 单槽位 Winner：同一页面只允许一个 popConfig.id 作为 Icon 归属者
const ensureIconWinner = (popConfig: any): boolean => {
  const nextId = `${popConfig?.id ?? ''}`;
  if (!nextId || nextId === 'undefined') return false;
  const current = sessionStorage?.getItem(ICON_WINNER_KEY);
  if (!current) {
    sessionStorage?.setItem(ICON_WINNER_KEY, nextId);
    return true;
  }
  return current === nextId;
};

/**
 * 更新 Icon Winner 为当前主动曝光的弹窗
 * 用于：当弹窗主动曝光时，Icon 归属切换为该弹窗
 */
export const updateIconWinnerOnPopupExpose = (popConfig: any): void => {
  const nextId = `${popConfig?.id ?? ''}`;
  if (!nextId || nextId === 'undefined') return;
  sessionStorage?.setItem(ICON_WINNER_KEY, nextId);
};

/**
 * 清理当前页面的 Icon Winner 归属。
 * 用于：用户手动关闭 icon 后，允许后续命中的其他弹窗重新竞争展示前 icon。
 */
export const clearIconWinner = (): void => {
  sessionStorage?.removeItem(ICON_WINNER_KEY);
};

/**
 * 检查当前弹窗是否为 Icon Winner
 */
export const isIconWinner = (popConfig: any): boolean => {
  const popId = `${popConfig?.id ?? ''}`;
  if (!popId || popId === 'undefined') return false;
  const winnerId = sessionStorage?.getItem(ICON_WINNER_KEY);
  return !winnerId || winnerId === popId;
};
export type IconTiming = 'after' | 'beforeAndAfter';

/**
 * 规范化后端下发的 icon 展示时机配置。
 *
 * 说明：
 * - 默认返回 `after`，保持与线上当前行为一致。
 * - 这里故意保持为纯函数，便于后续按单元逐步演进展示策略。
 */
export function normalizeIconTiming(value: unknown): IconTiming {
  if (value === 'after' || value === 'beforeAndAfter') {
    return value;
  }
  return 'after';
}

export function canShowIconBefore(value: unknown): boolean {
  const timing = normalizeIconTiming(value);
  return timing === 'beforeAndAfter';
}

/**
 * 「显示前 Icon」的时机 + 频控联动判断
 */
export function canShowIconBeforeWithFrequency(iconTiming: unknown, popConfig: any): boolean {
  if (!canShowIconBefore(iconTiming)) return false;
  if (!ensureIconWinner(popConfig)) return false;
  return canShowIconBeforeByFrequency(popConfig);
}

/**
 * 判断是否应该在「关闭后」显示 Icon
 * 关闭后显示完全绕过双层频控，仅受页面规则/人群命中/展示时机条件约束
 */
export function shouldShowIconAfterPopupClose(iconTiming: unknown, popConfig: any): boolean {
  const timing = normalizeIconTiming(iconTiming);
  // 两种时机都支持关闭后显示
  if (timing !== 'after' && timing !== 'beforeAndAfter') return false;
  // 检查是否为当前 Winner
  return isIconWinner(popConfig);
}
